import { BaseFetch } from "../main-model"
export default class PositionModel extends BaseFetch {
    getPositionBy = (data) =>
    this.authFetch({
      url: "position/getPositionBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getPositionById = (data) =>
    this.authFetch({
      url: "position/getPositionById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updatePositionById = (data) =>
    this.authFetch({
      url: "position/updatePositionById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertPosition = (data) =>
    this.authFetch({
      url: "position/insertPosition",
      method: "POST",
      body: JSON.stringify(data),
    })
    deletePositionById = (data) =>
    this.authFetch({
      url: "position/deletePositionById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
